<h2 class="title-white title-fixed">
    <ng-container i18n *ngIf="hurryUp">Hurry up</ng-container>
    <ng-container *ngIf="!hurryUp">
        <ng-content></ng-content>
    </ng-container>
</h2>

@if (ballShootIn) {
    <div class="phase-label yellow" i18n>Ball shoot in</div>
} @else if (hurryUp) {
    <div class="phase-label orange" i18n>Preparation time</div>
} @else if (!isClosed) {
    <div class="phase-label green" i18n>Game betting time</div>
} @else if (isClosed) {
    <div i18n class="phase-label">Wait for result</div>
} @else {
    <div class="phase-label">&nbsp;</div>
}

<div class="timer-wrapper">
    <app-loader
        [progress]="progress"
        [isClosed]="isClosed"
        [bettingTimeInSeconds]="initialTimeInSeconds"
        [hurryUpTimeInSeconds]="hurryUpTimeInSeconds"
    ></app-loader>

    <app-count-down
        *ngIf="!isClosed && isCountdownActive"
        class="hidden"
        [initialTimeInSeconds]="currentCountdownTime"
        (countDownProgressed)="onProgress($event)"
        (countDownProgressed)="onCountDownProgress($event)"
        (countDownFinished)="onCountDownFinished()"
    ></app-count-down>
</div>
